var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"d-flex justify-space-around align-center white",attrs:{"app":""}},[_c('i',{staticClass:"text-center",domProps:{"textContent":_vm._s('Copyright ©' + new Date().getFullYear() + ' Ludimation')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }